export default __webpack_public_path__ + "static/media/comingsoon.285d0ae9.svg";